import { OpenTabDetailFragment } from '@/features/graphql/generated/graphql'
import currencyJs from 'currency.js'

export const toAmount = (amount: string | undefined): number => currencyJs(amount ?? 0).value

export const resolveCurrency = (
    fallbackCurrency: string,
    ...prices: ({ currency: string } | null | undefined)[]
): string => prices.find(Boolean)?.currency ?? fallbackCurrency

type NamedProductVariant = { name?: string | null; product: { name: string } }

export const getProductVariantName = (variant: NamedProductVariant): string =>
    variant.name ? `${variant.product.name} · ${variant.name}` : variant.product.name

export const getLatestSettlement = (tab: Pick<OpenTabDetailFragment, 'settlements'>) =>
    tab.settlements.reduce<(typeof tab.settlements)[number] | undefined>(
        (latest, settlement) =>
            !latest ||
            Date.parse(String(settlement.createdAt)) > Date.parse(String(latest.createdAt))
                ? settlement
                : latest,
        undefined
    )
